import axios from 'axios'

class Api {

  constructor (url, accessToken='', apiKey='') {
    this.url = url
    this.apiKey = apiKey
    this.accessToken = accessToken
    // setPartner and setAccount mutations will change these
    this.partner_id = null
    this.account_id = null

    var headers = {}
    if (apiKey) {
      headers['X-Api-Key'] = apiKey
    }
    if (accessToken) {
      headers['Authorization'] = accessToken
    }

    this.instance = axios.create({
      baseURL: url,
      headers: headers
    });
  }

  get (path, params, sendAccount = true) {
    if (!(this.key || this.accessToken)) return

    if (!params) {params = {}}
    if (!params['partner_id'] && this.partner_id) {params['partner_id'] = this.partner_id}
    if (sendAccount && !params['account_id'] && this.account_id) {params['account_id'] = this.account_id}

    return this.instance.get(path, {params: params}).then(r => r.data)
      .catch(error => {
        // console.log(error)

        if (error.response.status === 401) {
          alert('Invalid API key or Access token')
        }
        return {}
      })
  }

  put (path, params, sendAccount = true) {
    if (!(this.key || this.accessToken)) return

    if (!params) {params = {}}
    if (!params['partner_id'] && this.partner_id) {params['partner_id'] = this.partner_id}
    if (sendAccount && !params['account_id'] && this.account_id) {params['account_id'] = this.account_id}

    var formData = new FormData()
    for (var param in params) {
      formData.set(param, params[param])
    }
    return this.instance.put(path, formData).then(r => r.data)
  }

  post (path, params, sendAccount = true) {
    if (!(this.key || this.accessToken)) return

    if (!params) {params = {}}
    if (!params['partner_id'] && this.partner_id) {params['partner_id'] = this.partner_id}
    if (sendAccount && !params['account_id'] && this.account_id) {params['account_id'] = this.account_id}

    var formData = new FormData()
    for (var param in params) {
      formData.set(param, params[param])
    }
    return this.instance.post(path, formData).then(r => r.data)
  }

  delete (path, params, sendAccount = true) {
    if (!(this.key || this.accessToken)) return

    if (!params) {params = {}}
    if (!params['partner_id'] && this.partner_id) {params['partner_id'] = this.partner_id}
    if (sendAccount && !params['account_id'] && this.account_id) {params['account_id'] = this.account_id}
    
    return this.instance.delete(path, { data: params }).then(r => r.data)
  }

  download (path, params, filename) {
    
    if (!params) {params = {}}
    if (!params['partner_id'] && this.partner_id) {params['partner_id'] = this.partner_id}
    if (!params['account_id'] && this.account_id) {params['account_id'] = this.account_id}
    
    return axios({
      url: this.url + path,
      method: 'GET',
      params: params,
      headers: {
        'Authorization': this.accessToken
      },
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    });
  }

}

export default Api
